import { NgModule } from '@angular/core';
import { AppsSharedModule, BaseAssignmentsModule, BaseSharedModule, BaseInquiryModule } from 'base';
import { BaseCustomerOffersListComponent } from './_components/list/offers-list.component';
import { BaseCustomerOffersListHeadlineComponent } from './_components/list-headline/offers-list-headline.component';
import { BaseCustomerOffersListItemComponent } from './_components/list-item/offers-list-item.component';
import { BaseCustomerOffersFiltersAndSearchComponent } from './_components/filters-and-search/offers-filters-and-search.component';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerOfferActionButtonsComponent } from './_components/offer-action-buttons/offer-action-buttons.component';
import { BaseCustomerOfferModalComponent } from './_components/offer-modal/offer-modal.component';
import { BaseCustomerInquiryModule } from '../inquiry/inquiry.module';

@NgModule({
  imports: [
    BaseSharedModule,
    AppsSharedModule,
    BaseCustomerSharedModule,
    BaseAssignmentsModule,
    BaseCustomerInquiryModule,
    BaseInquiryModule,
  ],
  declarations: [
    BaseCustomerOffersListComponent,
    BaseCustomerOffersListHeadlineComponent,
    BaseCustomerOffersListItemComponent,
    BaseCustomerOffersFiltersAndSearchComponent,
    BaseCustomerOfferActionButtonsComponent,
    BaseCustomerOfferModalComponent,
  ],
  exports: [BaseCustomerOffersListComponent],
})
export class BaseCustomerOffersModule {}
